import { render, staticRenderFns } from "./MaucashModel.vue?vue&type=template&id=1fff43dc&scoped=true&"
import script from "./MaucashModel.vue?vue&type=script&lang=ts&"
export * from "./MaucashModel.vue?vue&type=script&lang=ts&"
import style0 from "./MaucashModel.vue?vue&type=style&index=0&id=1fff43dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fff43dc",
  null
  
)

export default component.exports